import type { AccessibleAnchorHTMLAttributes } from 'preact'
import './index.css'

// Anchor attributes with a required href (which restricts `role` to link-like roles)
type LinkProps = AccessibleAnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string
}

const Link = (props: LinkProps) => {
  return <a className="link" {...props} />
}

export default Link
